import React, { useMemo } from 'react';
import {
  alpha,
  AppBar,
  Box,
  Breadcrumbs,
  IconButton,
  Link,
  styled,
  Toolbar,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import MobileHidden from 'components/MobileHidden';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import { useLocation } from 'react-router-dom';
import { getMenu } from 'utils/getMenu';
import Header from 'components/Header';

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 42;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha('#F1EFE6', 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

interface IProps {
  onOpenSidebar: () => void;
}

export function Navbar({ onOpenSidebar }: IProps) {
  const location = useLocation();

  const breadcrumb = useMemo(() => {
    const paths = location.pathname.split('/').splice(1);

    return paths.map((item) => {
      if (paths[0].length === 0) {
        return '';
      }

      return getMenu(`/${item}`);
    });
  }, [location]);

  return <Header />;
}
